<script setup lang="ts">
import router from '@/router';
import EmployeeList from '@/components/EmployeeList.vue';
import EmployeeListLoader from '@/components/EmployeeListLoader.vue';

import { useRootStore } from '@/stores/root';
import { getTranslations } from '@/lib/util/i18n';
import { useTimesheetStore } from '@/stores/timesheets';
import { CoButton } from '@deputy/copilot2';
import { onBeforeMount, ref } from 'vue';
import { useRosterStore } from '@/stores/rosters';
import { useEmployeeWithTimesheetsStore } from '@/stores/employeesWithTimesheets/employeesWithTimesheets';

const rootStore = useRootStore();
const timesheets = useTimesheetStore();
const rosters = useRosterStore();
const employeeWithTimesheetsStore = useEmployeeWithTimesheetsStore();
const isReady = ref(false);

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'home-view',
});

function reload(): void {
  window.location.reload();
}

onBeforeMount(async () => {
  await Promise.all([timesheets.load(), rosters.load()]);
  employeeWithTimesheetsStore.load();

  isReady.value = true;
});

function selectEmployee(id: number): void {
  router.push({ name: 'login', params: { id } });
}
</script>

<template>
  <div class="__employee-container">
    <div
      v-if="rootStore.isInitializing() || !isReady"
      data-test-id="employees-loading"
    >
      <EmployeeListLoader></EmployeeListLoader>
    </div>
    <div v-else-if="!rootStore.getInitializeError()">
      <EmployeeList @select="selectEmployee" />
    </div>
    <div data-test-id="loading-error" class="__error" v-else>
      <p>{{ t('loading-failed') }}</p>
      <CoButton size="large" @click="reload">
        {{ t('reload') }}
      </CoButton>
    </div>
  </div>
</template>

<style scoped>
.__employee-container {
  width: 808px;
  box-sizing: content-box;
  padding: 0 2rem;
}

@media (max-width: 1200px) {
  .__employee-container {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .__employee-container {
    padding: 1rem;
  }
}

.__search {
  margin: 20px 0;
}

.__error {
  text-align: center;
  font-size: 18px;
}
.__error .co-button {
  margin-top: 20px;
}
</style>
